export default "__VITE_ASSET__BH74$hvp__"